import styled from 'styled-components';

const PartnersStyle = styled.div`
	--spaceItemDistance: var(--sp1x);

	.title {
		margin-bottom: var(--titleToContent);
	}

	.partnersLogoCont {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: calc(var(--spaceItemDistance) * -1) !important;

		.partnersLogoItem {
			flex: 0 0 50%;
			max-width: calc(50% - var(--sp1x));
			margin-bottom: var(--spaceItemDistance);

			a {
				display: block;
			}

			.darkMode {
				img {
					filter: invert(1);
				}
			}

			.partnersLogoWrap {
				padding-top: 100%;

				> div {
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--spaceItemDistance: var(--sp2x);

		.partnersLogoCont {
			.partnersLogoItem {
				flex: 0 0 33.33%;
				max-width: calc(33.33%);
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.partnersLogoCont {
			--spaces-item: 7%;

			justify-content: flex-start;
			margin: 0 calc(var(--spaces-item) * -1);

			.partnersLogoItem {
				padding: 0 var(--spaces-item);
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--spaceItemDistance: var(--sp5x);

		.partnersLogoCont {
			--spaces-item: 2.5%;

			.partnersLogoItem {
				flex: 0 0 16.6%;
				max-width: calc(16.6%);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--spaceItemDistance: var(--sp6x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--spaceItemDistance: var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--spaceItemDistance: var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--spaceItemDistance: var(--sp10x);

		.partnersLogoCont {
			--spaces-item: 4%;
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		--spaceItemDistance: var(--sp12x);

		.partnersLogoCont {
			--spaces-item: 3.8%;
		}
	}
`;

export default PartnersStyle;
